import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ListExaminations from "../../components/Sample/ListExaminations";
import ListUrineSample from "../../components/Sample/ListUrineSample";
import {getTestByType} from '../../Api/tests';
function Examinations() {
  const [data, setData] = useState([]);
  useEffect(()=>{
    getTestByType(3, setData);
  }, []);
  return (
    <div className="w-full h-full">
      <Header Section="Sample" />
      <div className="w-full h-full flex flex-col px-2 lg:px-20 mt-10  mb-20">
        <div className="w-full flex space-x-5 border-b-2 pb-2">
          <Link to="/" className="font-Lato-Regular text-xl text-[#B7C933]">
            Home
          </Link>
          <p className="font-Lato-Regular text-xl text-[#B7C933]">|</p>
          <Link
            to="/Sample"
            className="font-Lato-Regular text-xl text-[#B7C933]"
          >
            Sample
          </Link>
          <p className="font-Lato-Regular text-xl pl-5">
            Examinations that require protection from light
          </p>
        </div>
        <div className="w-full mt-10">
          <h1 className="text-2xl font-Lato-Bold">
            Examinations that require protection from light
          </h1>
          <p className="font-Lato-Regular text-lg mt-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
        </div>
        <ListExaminations Data={data} />
      </div>
      <Footer />
    </div>
  );
}

export default Examinations;
